import React, { FC, Dispatch, SetStateAction, useContext } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import CustomAccordion from '../../../sharedModules/layout/CustomAccordion';
import ObjectBreakdown from '../../../sharedModules/layout/ObjectBreakdown';

import Help from '@mui/icons-material/Help';
import Visibility from '@mui/icons-material/Visibility';
import Delete from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import { DeleteConfirmationModalContext } from '../../../sharedModules/contexts/DeleteConfirmationModalContext';

import { AhriCertificate } from '../../model';

interface CertificateInfoCardProps {
  certificate: any;
  setCertificateToReport?: Dispatch<SetStateAction<AhriCertificate>>;
  setReviewDialogOpen?: Dispatch<SetStateAction<boolean>>;
}

const CertificateInfoCard: FC<CertificateInfoCardProps> = (props) => {
  let { certificate, setCertificateToReport, setReviewDialogOpen } = props;

  let { setModelLabel, setDeleteConfirmationModalOpen, setRecordToDelete, setDeleteURL } =
    useContext(DeleteConfirmationModalContext);

  const handleViewCertificate = () => {
    if (certificate.certificate_url && certificate.certificate_url !== 'Not Found') {
      window.open(certificate.certificate_url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleHelpClicked = () => {
    setReviewDialogOpen(true);
    setCertificateToReport(certificate);
  };

  const handleRemoveClicked = () => {
    setDeleteURL('energy_solutions/ahri_certificates');
    setModelLabel('AHRI Certificate');
    setDeleteConfirmationModalOpen(true);
    setRecordToDelete(certificate);
  };

  return (
    <Card>
      <Grid container>
        <Grid item xs={12} sx={{ p: '5px', pl: '15px' }}>
          <Grid container style={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={6} md={3}>
              {certificate.manufacturer_name}
            </Grid>
            <Grid item xs={6} md={4}>
              {certificate.model_number}
            </Grid>
            <Grid item xs={12} md={5}>
              <Box display="flex" gap={1} justifyContent="flex-end" alignItems="center">
                {certificate.certificate_url !== 'Not Found' ? (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Visibility />}
                    onClick={handleViewCertificate}
                    sx={{ minWidth: 'auto' }}
                  >
                    View Certificate
                  </Button>
                ) : (
                  <Button variant="outlined" size="small" disabled sx={{ minWidth: 'auto' }}>
                    Not Found
                  </Button>
                )}
                {setReviewDialogOpen && (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Help />}
                    onClick={handleHelpClicked}
                    color="info"
                    sx={{ minWidth: 'auto' }}
                  >
                    Report Issue
                  </Button>
                )}

                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Delete />}
                  onClick={handleRemoveClicked}
                  color="error"
                  sx={{ minWidth: 'auto' }}
                >
                  Remove
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CustomAccordion
            summary="AHRI Info"
            detailComponent={<ObjectBreakdown data={certificate.ahri_info} />}
            backgroundColor="#E3BDC2"
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default CertificateInfoCard;
